const bounds = new google.maps.LatLngBounds();
const infoWindow = new google.maps.InfoWindow();
const modalActiveClass = 'localAreaMap__modal--active';

let map = null;
let isTab = false;

const MapComponent = () => {

    // Get map & location data
    let mapData = initMap();

    // Load map
    map = mapData.map;

    // Add markers to map & set bounds
    plotMarkers(mapData.locations);

    // Redraw map bounds to combat resize event bug with Google Maps
    if (isTab) {
        $('.sites__optsItem').click(() => {
            map.fitBounds(bounds);
        })
    }
}

const initMap = () => {

    const developments = $('.map-component__location');
    let locations = [];

    if (developments.closest('.tabSection').length > 0) {
        isTab = true;
    }

    // Setup locations array with developments that have a lat/long assigned
    developments.each((index, dev) => {

        const { lat, long, title, image, status, icon, address, bedrooms, price, link } = $(dev).data();

        if (lat != '' && long != '') {
            locations.push({
                lat: parseFloat(lat),
                long: parseFloat(long),
                title: title,
                image: image,
                status: status,
                icon: icon,
                address: address,
                bedrooms: bedrooms,
                price: price,
                link: link
            })
        }
    });

    document.onkeydown = function(event) {
        if (event.keyCode === 27) {
            closeModal();
        }
    };

    document.querySelector('.localAreaMap__modalClose').addEventListener('click', (e) => {
        closeModal();
    })

    return {
        map: new google.maps.Map(document.getElementById("development-map"), {
            zoom: 10,
            center: {
                lat: 52.357351, lng: -1.827748
            },
            styles: getStyles(),
        }),
        locations: locations
    }
}

const plotMarkers = (locations) => {
    Array.prototype.forEach.call(locations, (location) => {
        let marker = new google.maps.Marker({
            position: {
                lat: location.lat,
                lng: location.long
            },
            map: map,
            icon: getIconStyles(location.status)
        });

        marker.addListener('click', () => {
            const modal = document.querySelector('.map-component .localAreaMap__modal');
            const modalBanner = document.querySelector('.map-component .development-card__banner');
            const modalIcon = document.querySelector('.map-component .development-card__icon');
            const modalTitle = document.querySelector('.map-component .development-card__title');
            const modalAddress = document.querySelector('.map-component .development-card__address');
            const modalBedrooms = document.querySelector('.map-component .development-card__bedroom-details');
            const modalPrice = document.querySelector('.map-component .development-card__price');
            const modalButton = document.querySelector('.map-component .development-card__button');

            const { image, title, icon, address, bedrooms, price, status, link } = location;

            modal.classList.remove(modalActiveClass);

            const returnContent = () => {
                modalBanner.style.backgroundImage = `url(${image})`;
                modalIcon.src = icon
                modalTitle.innerHTML = title;
                modalAddress.innerHTML = address;
                modalBedrooms.innerHTML = bedrooms;
                modalPrice.innerHTML = `£${price}`;
                modal.classList.add(modalActiveClass);

                if (status != 'available') {
                    modalButton.classList.add('development-card__button--disabled')
                } else {
                    modalButton.classList.remove('development-card__button--disabled')
                    modalButton.href = link;
                }
            }

            setTimeout(returnContent, 300);
        })

        bounds.extend(marker.position);
    });

    if (!isTab) {
        map.fitBounds(bounds);
    }
}


const closeModal = () => {
    const modal = document.querySelector('.localAreaMap__modal');
    modal.classList.contains(modalActiveClass) ? document.querySelector('.localAreaMap__modal--active').classList.remove('localAreaMap__modal--active') : null;
}

// Returns an array of Google Map styles.
const getStyles = () => {
    return [
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e9e9e9"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dedede"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#333333"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f2f2f2"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        }
    ];
}

// Sets up icon styles and returns them as an object
const getIconStyles = (status) => {

    let fillColor;

    switch (status) {
        case "available":
            fillColor = "#689C71";
            break;
        case "coming-soon":
            fillColor = "#222B32";
            break;
        case "sold":
            fillColor = "#9C938C";
            break;
        default:
            fillColor = '#222B32';
    }

    return {
        path: "M23.175.019C36.705-.51 47.848 10.3 47.848 23.747 47.583 37.46 35.38 50.904 25.297 59.604a2.42 2.42 0 0 1-2.654 0C12.032 50.375-1.234 35.875.093 21.373 1.42 9.775 11.237.547 23.174.019z",
        fillColor: fillColor,
        fillOpacity: 1,
        scale: 0.75,
        strokeOpacity: 0
    };

}

export default MapComponent;


// WEBPACK FOOTER //
// ./src/js/app/components/MapComponent.js